import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

interface ModalProps {
    isActive: boolean;
    onClose: () => void;
    disableBackdropClick?: boolean,
    headerRightComponent?: React.ReactNode,
    description?: React.ReactNode,
    remount?: boolean
}

const inModal = <P extends object>(WrappedComponent: React.ComponentType<P>, title: string) => {
    const MilestoneOffcanvas: React.FC<P & ModalProps> = ({
        isActive,
        disableBackdropClick = false,
        onClose,
        headerRightComponent,
        description,
        remount = true,
        ...props
    }) => {

        const onBackDropClick = () => {
            if (disableBackdropClick) return;
            onClose();
        }

        return (
            <Modal centered isOpen={isActive} toggle={onClose} direction='end' id="milestone-modal" unmountOnClose={remount}>
                <div className="d-flex align-items-center justify-content-between w-100 modal-header">
                    <div className="d-flex flex-column justify-content-between w-50">
                        <h4>{title}</h4>
                        {description}
                    </div>
                    {headerRightComponent}
                </div>
                <ModalBody>
                    {
                        remount ? (
                            <>
                                {
                                    isActive && <WrappedComponent {...(props as P)} onClose={onClose} />
                                }
                            </>
                        ) : (
                            <WrappedComponent {...(props as P)} onClose={onClose} />
                        )
                    }
                </ModalBody>
            </Modal>
        );
    };

    return MilestoneOffcanvas;
};

export default inModal;